module.exports = "/packs/images/products/collections/0-ef92dbd9171a2f08651cbf578f63f2b2.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/collections/0.png
// module id = 1803
// module chunks = 0